/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import './styles.scss'

class ProductCard {
  constructor (element) {
    this.$el = $(element)
  }
}

registerClass('ProductCard', ProductCard)
